<template>
  <div class="seth-set bg-primary">
    <div class="absolute top-0 py-10 w-full px-6 flex justify-between">
      <div>
        <p
          @click="handleback('myAdmin')"
          class="gap-2 cursor-pointer fsize14 text-white flex items-center"
        >
          <feather-icon
            class="flex"
            icon="ArrowLeftIcon"
            svgClasses="w-6 h-6"
          />
          Go Back
        </p>
        <h2 class="text-white pt-1 text-2xl capitalize font-semibold">Chats</h2>
      </div>
      <div class="flex gap-4 items-center">
        <!-- <feather-icon icon="BellIcon" class="text-white" /> -->
        <vs-button
          color="white"
          class="bg-white text-primary w-full"
          @click="handleback('pick-template')"
          >Select Template</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleback(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
